import { Component, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-text-to-search-dropdown',
  templateUrl: './text-to-search-dropdown.component.html',
  styleUrls: ['./text-to-search-dropdown.component.scss'],
})
export class TextToSearchDropdownComponent {
  @Input() placeholder = 'Search...';
  @Input() fetchFn!: (term: string) => any;
  @Input() formControl!: FormControl;

  @ViewChild('overlayRef') overlayRef!: OverlayPanel;

  searchResults: any[] = [];
  noResultsMessage: string | null = null;

  private searchTerms$ = new Subject<string>();

  ngOnInit(): void {
    this.searchTerms$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) => {
          if (!term || term.length < 3) {
            this.searchResults = [];
            this.noResultsMessage = 'Enter at least 3 characters to search';
            return of([]);
          } else {
            return this.fetchFn(term);
          }
        })
      )
      .subscribe((results: any[]) => {
        if (this.formControl?.value?.length >= 3) {
          this.searchResults = results;
          this.noResultsMessage =
            results.length === 0 ? 'No results found' : null;
        }
      });
  }

  onInputChange(event: Event, overlay: OverlayPanel) {
    const val = (event.target as HTMLInputElement).value;
    this.formControl.setValue(val);
    this.searchTerms$.next(val);
    overlay.show(event);
  }

  onFocus(event: FocusEvent, overlay: OverlayPanel) {
    if (!this.formControl?.value || this.formControl?.value.length < 3) {
      this.noResultsMessage = 'Enter at least 3 characters to search';
      overlay.show(event);
    } else {
      this.searchTerms$.next(this.formControl.value);
      overlay.show(event);
    }
  }

  onBlur() {
    // handle blur if needed
  }

  selectOption(item: any, overlay: OverlayPanel) {
    this.formControl.setValue(item.port_name || item.label);
    overlay.hide();
  }
}
